/** @file Sign-out: POST /auth/logout, then forget the session and the open project. */
import type { ApiClient } from '../../api/createApiClient';
import { docStore } from '../../stores/docStore';
import { sessionStore } from '../../stores/sessionStore';

/** The route guard sends the user to /login once the status is `anonymous`. */
export async function signOut(client: Pick<ApiClient, 'logout'>): Promise<void> {
  await client.logout();
  docStore.setState(docStore.getInitialState(), true);
  sessionStore.setState({ status: 'anonymous', actor: null });
}
